var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 268.22,
    height: 187.545,
    viewBox: "0 0 268.22 187.545",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: -0.011,
    x2: 0.5,
    y2: 0.996,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "info",
    transform: "translate(-62.28 -56)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS",
    transform: "translate(62.28 56)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_307",
    "data-name": "Group 307"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_643",
    "data-name": "Path 643",
    d: "M60.966,203.272s-28.556-33.28,3.612-69.5c25.929-29.192,17.65-40.482,16.454-60.167-1.012-16.663,17.884-41.3,46.161-42.531,46.349-2.016,59.5,36.542,84.11,35.489s34.107-33.331,62.689-29.937c53.038,6.3,45.89,56.567,38.16,94.14s15.5,50.4-1.217,72.533",
    transform: "translate(-49.28 -31)",
    fill: "#9fc1f4",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_644",
    "data-name": "Path 644",
    d: "M411.926,71.97a10.771,10.771,0,0,0,6.082-.52,30.966,30.966,0,0,0,11.453-7.365c5.8-6.173,7.431-6.341,8.938-8.735s0-7.811-10.712-3.527C417.759,55.793,399.935,69.349,411.926,71.97Z",
    transform: "translate(-246.559 -41.575)",
    fill: "#9fc1f4",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_645",
    "data-name": "Path 645",
    d: "M60.683,247.325c1.73-2.017,3.519-3.988,5.346-5.918,2.86-3.022,6.625-7.547,7.075-10.838.736-5.386-4.636-5-9.5-.21C55.359,238.469,52.29,257.113,60.683,247.325Z",
    transform: "translate(-52.815 -138.62)",
    fill: "#9fc1f4",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_314",
    "data-name": "Group 314",
    transform: "translate(28.595 109.86)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_309",
    "data-name": "Group 309",
    transform: "translate(20.106)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_308",
    "data-name": "Group 308"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_646",
    "data-name": "Path 646",
    d: "M179.207,318.1a25.3,25.3,0,0,0,1.314-11.394,32.549,32.549,0,0,0-1.975-9.239c-1.038-2.548-3.085-1.447-5.061-2.461-1.262-.648-1.706-2.246-1.707-3.665a18.72,18.72,0,0,0-.015-4.124,3.336,3.336,0,0,0-1.967-2.467c-1.284-.394-2.383.881-3.581-.142a3.845,3.845,0,0,1-1.064-1.894,29.887,29.887,0,0,0-1.774-4.821c-.691-1.406-1.9-2.941-3.449-2.7-1.486.232-2.2,1.963-2.35,3.46a15.483,15.483,0,0,0,3.056,10.182,10.508,10.508,0,0,1,1.513,2.533,2.711,2.711,0,0,1-.45,2.772c-.378.374-.894.577-1.291.931-1.1.983-.927,2.8-.2,4.083,1.878,3.3,5.9,2.878,8.622,5.106,3.084,2.525,6.735,7.418,6.14,11.682",
    transform: "translate(-157.522 -275.172)",
    fill: "#71afef"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_647",
    "data-name": "Path 647",
    d: "M179.666,315.656a25.831,25.831,0,0,0-4.711-14.9c-1.914-2.719-4.325-5.044-6.342-7.686s-4.439-6.282-4.439-11.641",
    transform: "translate(-161.181 -278.614)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.891,
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_310",
    "data-name": "Group 310",
    transform: "translate(0 20.836)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_648",
    "data-name": "Path 648",
    d: "M216.042,363.052c-30.215-.015-73.347.1-101.462-.015-.945,0-3.965-.994,1.166-4.3,4.346-2.8,18.082-.281,18.082-.281s-3.2-1.282-3.183-2.936a4.483,4.483,0,0,1,2.774-3.795,10.3,10.3,0,0,1,4.872-.642,31.059,31.059,0,0,1,9.813,2.2,2.846,2.846,0,1,1,3.3-4.62c-2.11-2.858-5.372-15.52,4.653-21.1,12.565-6.995,22.108-1.239,24.144,2.971,1.033-4.132,5.774-7.261,8.9-8.037,7.122-1.768,11.761-1.244,18.41,1.861,2.352,1.1,5.5,4.85,7.065,6.922,2.449,3.245,2.831,7.562,2.965,11.625q.152,4.575.041,9.153",
    transform: "translate(-112.835 -321.482)",
    fill: "#71afef"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_311",
    "data-name": "Group 311",
    transform: "translate(110.719 20.836)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_649",
    "data-name": "Path 649",
    d: "M360.5,363.052c30.215-.015,73.347.1,101.462-.015.945,0,3.965-.994-1.166-4.3-4.346-2.8-18.082-.281-18.082-.281s3.2-1.282,3.183-2.936a4.483,4.483,0,0,0-2.774-3.795,10.3,10.3,0,0,0-4.872-.642,31.059,31.059,0,0,0-9.813,2.2,2.846,2.846,0,1,0-3.3-4.62c2.11-2.858,5.372-15.52-4.653-21.1-12.565-6.995-22.108-1.239-24.144,2.971-1.033-4.132-5.774-7.261-8.9-8.037-7.122-1.768-11.761-1.244-18.41,1.861-2.352,1.1-5.5,4.85-7.065,6.922-2.449,3.245-2.83,7.562-2.965,11.625q-.152,4.575-.041,9.153",
    transform: "translate(-358.917 -321.482)",
    fill: "#71afef"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_312",
    "data-name": "Group 312",
    transform: "translate(67.897 35.684)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_650",
    "data-name": "Path 650",
    d: "M286.943,381.209H266.028c-4.081,0-3.419-4.839,7.935-2.687-2.786-1.273-2.8-2.978-2.566-3.433a1.769,1.769,0,0,1,1.482-.646c1.444.124,2.54,1.009,3.806,1.716a8.125,8.125,0,0,1-3.619-6.95,2.887,2.887,0,0,1,.739-2.064,3.054,3.054,0,0,1,2.461-.789c1.532.3,4.349,2.862,5.471,3.948-5.721-5.262-7.9-13.554-4.237-15.445,6.166-3.184,10.823,14.854,10.823,14.854s-3.067-13.555,2.077-13.635.961,15.747.961,15.747",
    transform: "translate(-263.741 -354.482)",
    fill: "#9fc1f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_313",
    "data-name": "Group 313",
    transform: "translate(120.849 31.552)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_651",
    "data-name": "Path 651",
    d: "M388.384,376.157h24.149c4.712,0,3.947-5.588-9.161-3.1,3.216-1.47,3.235-3.438,2.962-3.964a2.044,2.044,0,0,0-1.711-.746c-1.667.143-2.933,1.165-4.394,1.982a9.384,9.384,0,0,0,4.179-8.025,3.333,3.333,0,0,0-.854-2.383,3.525,3.525,0,0,0-2.841-.911c-1.769.351-5.021,3.3-6.317,4.559,6.605-6.076,9.12-15.649,4.892-17.833-7.119-3.677-12.5,17.151-12.5,17.151s3.541-15.651-2.4-15.743-1.11,18.182-1.11,18.182",
    transform: "translate(-381.431 -345.298)",
    fill: "#9fc1f4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_334",
    "data-name": "Group 334",
    transform: "translate(230.246 111.293)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_321",
    "data-name": "Group 321",
    transform: "translate(0 14.26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_652",
    "data-name": "Path 652",
    d: "M577.286,346.835s-21.775-29.415-14.942-35.7S579.162,326.985,577.286,346.835Z",
    transform: "translate(-561.017 -310.051)",
    fill: "#a4cdf6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_316",
    "data-name": "Group 316",
    transform: "translate(3.34 4.341)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_315",
    "data-name": "Group 315"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_653",
    "data-name": "Path 653",
    d: "M568.467,319.93a84.437,84.437,0,0,1,9.282,19.15q1.48,4.405,2.53,8.937c.655,2.832,1.083,5.7,1.67,8.546a.138.138,0,0,0,.269-.036,83.3,83.3,0,0,0-13.478-36.756c-.116-.164-.386-.013-.274.16Z",
    transform: "translate(-568.44 -319.699)",
    fill: "#004f9f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_318",
    "data-name": "Group 318",
    transform: "translate(2.74 8.348)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_317",
    "data-name": "Group 317"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_654",
    "data-name": "Path 654",
    d: "M567.17,328.857c1.842,1.3,3.584,2.791,5.451,4.048.117.079.225-.089.143-.185a17.676,17.676,0,0,0-5.456-4.1.136.136,0,0,0-.137.234Z",
    transform: "translate(-567.106 -328.606)",
    fill: "#7878c4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_320",
    "data-name": "Group 320",
    transform: "translate(3.414 10.11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_319",
    "data-name": "Group 319"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_655",
    "data-name": "Path 655",
    d: "M568.668,332.772c1.842,1.3,3.584,2.791,5.451,4.048.117.079.224-.089.143-.185a17.676,17.676,0,0,0-5.456-4.1.136.136,0,0,0-.137.234Z",
    transform: "translate(-568.604 -332.521)",
    fill: "#7878c4"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_326",
    "data-name": "Group 326",
    transform: "translate(19.736 10.577)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_656",
    "data-name": "Path 656",
    d: "M606.591,338.964s20.994-29.978,14-36.078S604.193,319.17,606.591,338.964Z",
    transform: "translate(-605.612 -301.865)",
    fill: "#a4cdf6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_323",
    "data-name": "Group 323",
    transform: "translate(0 4.329)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_322",
    "data-name": "Group 322"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_657",
    "data-name": "Path 657",
    d: "M617.636,311.56a76.428,76.428,0,0,0-9.368,20.682,77.768,77.768,0,0,0-3.386,18.808c0,.151.246.192.269.036.454-2.982.763-5.978,1.3-8.949a97.286,97.286,0,0,1,2.25-9.585,84.523,84.523,0,0,1,9.205-20.834c.107-.174-.162-.328-.273-.159Z",
    transform: "translate(-604.883 -311.487)",
    fill: "#004f9f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_325",
    "data-name": "Group 325",
    transform: "translate(1.544 22.613)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_324",
    "data-name": "Group 324"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_658",
    "data-name": "Path 658",
    d: "M608.359,352.254a28.6,28.6,0,0,0,.49,7.467.118.118,0,0,0,.231-.031,33.882,33.882,0,0,0-.183-3.495c-.084-1.313-.128-2.633-.267-3.941a.136.136,0,0,0-.272,0Z",
    transform: "translate(-608.313 -352.123)",
    fill: "#0e7c74"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_329",
    "data-name": "Group 329",
    transform: "translate(3.503)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_659",
    "data-name": "Path 659",
    d: "M584.374,315.4s-21.128-29.883-14.16-36.014S586.682,295.6,584.374,315.4Z",
    transform: "translate(-568.804 -278.356)",
    fill: "#4e9dee"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_328",
    "data-name": "Group 328",
    transform: "translate(3.35 4.331)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_327",
    "data-name": "Group 327"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_660",
    "data-name": "Path 660",
    d: "M576.274,288.215a90.373,90.373,0,0,1,12.8,38.883c.279,2.754.4,5.515.6,8.273a.137.137,0,0,0,.274,0,83.038,83.038,0,0,0-1.446-15.92,88.524,88.524,0,0,0-5.737-19.779,73.04,73.04,0,0,0-6.221-11.617c-.112-.168-.382-.014-.273.16Z",
    transform: "translate(-576.249 -287.983)",
    fill: "#004f9f"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_332",
    "data-name": "Group 332",
    transform: "translate(16.712 23.491)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_661",
    "data-name": "Path 661",
    d: "M600.391,352.839s13-17.869,8.846-21.629S599.16,340.862,600.391,352.839Z",
    transform: "translate(-599.297 -330.566)",
    fill: "#4e9dee"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_331",
    "data-name": "Group 331",
    transform: "translate(0 2.559)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_330",
    "data-name": "Group 330"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_662",
    "data-name": "Path 662",
    d: "M606.667,336.326a53.1,53.1,0,0,0-8.481,28.491.137.137,0,0,0,.274,0,104.863,104.863,0,0,1,1.878-12.759,53.212,53.212,0,0,1,6.6-15.572c.11-.174-.159-.325-.273-.16Z",
    transform: "translate(-598.161 -336.254)",
    fill: "#004f9f"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_333",
    "data-name": "Group 333",
    transform: "translate(8.077 44.162)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_663",
    "data-name": "Path 663",
    d: "M598.963,378.156l-.1.683-.215,1.452-2.077,13.941h-12.39L582.1,380.291l-.215-1.452-.1-.683Z",
    transform: "translate(-580.517 -377.415)",
    fill: "#b5d0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_664",
    "data-name": "Path 664",
    d: "M598.986,379.674l-.215,1.452H582.227l-.215-1.452Z",
    transform: "translate(-580.642 -378.25)",
    fill: "#73b8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_665",
    "data-name": "Path 665",
    d: "M597.655,378.56H579.993a1.025,1.025,0,0,1-1.025-1.025h0a1.025,1.025,0,0,1,1.025-1.025h17.662a1.025,1.025,0,0,1,1.025,1.025h0A1.025,1.025,0,0,1,597.655,378.56Z",
    transform: "translate(-578.968 -376.51)",
    fill: "#73b8ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_338",
    "data-name": "Group 338",
    transform: "translate(61.075 55.111)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_666",
    "data-name": "Path 666",
    d: "M348.67,373.552H313.04l3.87-15.216.877-3.451,1.7-6.682h22.73l1.7,6.682.877,3.451Z",
    transform: "translate(-255.441 -260.595)",
    fill: "#004f9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_667",
    "data-name": "Path 667",
    d: "M349.53,366.505H321.641l.877-3.451h26.135Z",
    transform: "translate(-260.172 -268.764)",
    fill: "#034a93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_668",
    "data-name": "Path 668",
    d: "M335.854,157.233v86.889a3.746,3.746,0,0,1-3.745,3.745H188.768a3.743,3.743,0,0,1-3.745-3.745V157.233a3.743,3.743,0,0,1,3.745-3.745H332.11A3.746,3.746,0,0,1,335.854,157.233Z",
    transform: "translate(-185.023 -153.488)",
    fill: "#004f9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_669",
    "data-name": "Path 669",
    d: "M342.279,407.2H279.3a2.736,2.736,0,0,1-2.736-2.736h0a2.736,2.736,0,0,1,2.736-2.736h62.977a2.736,2.736,0,0,1,2.736,2.736h0A2.736,2.736,0,0,1,342.279,407.2Z",
    transform: "translate(-235.378 -290.035)",
    fill: "#004f9f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_67",
    "data-name": "Rectangle 67",
    width: 145.034,
    height: 76.595,
    transform: "translate(2.759 2.749)",
    fill: "#9fc1f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_670",
    "data-name": "Path 670",
    d: "M348.365,345.226h0a3.488,3.488,0,0,1-3.478-3.478h0a3.488,3.488,0,0,1,3.478-3.478h0a3.488,3.488,0,0,1,3.478,3.478h0A3.487,3.487,0,0,1,348.365,345.226Z",
    transform: "translate(-272.959 -255.132)",
    fill: "#003469"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_336",
    "data-name": "Group 336",
    transform: "translate(46.292 68.687)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_335",
    "data-name": "Group 335",
    transform: "translate(0.538 0.636)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_68",
    "data-name": "Rectangle 68",
    width: 2.579,
    height: 5.627,
    transform: "translate(46.96)",
    fill: "#5146af",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_69",
    "data-name": "Rectangle 69",
    width: 2.579,
    height: 5.627,
    transform: "translate(49.895)",
    fill: "#5146af",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70",
    "data-name": "Rectangle 70",
    width: 2.579,
    height: 5.627,
    transform: "translate(52.83)",
    fill: "#5146af",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_71",
    "data-name": "Rectangle 71",
    width: 2.579,
    height: 5.627,
    fill: "#5146af"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_72",
    "data-name": "Rectangle 72",
    width: 2.579,
    height: 5.627,
    transform: "translate(2.935)",
    fill: "#5146af"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_73",
    "data-name": "Rectangle 73",
    width: 2.579,
    height: 5.627,
    transform: "translate(5.87)",
    fill: "#5146af"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_74",
    "data-name": "Rectangle 74",
    width: 2.579,
    height: 5.627,
    transform: "translate(8.805)",
    fill: "#5146af"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_75",
    "data-name": "Rectangle 75",
    width: 2.579,
    height: 5.627,
    transform: "translate(11.74)",
    fill: "#5146af"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_76",
    "data-name": "Rectangle 76",
    width: 2.579,
    height: 5.627,
    transform: "translate(14.675)",
    fill: "#5146af"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_77",
    "data-name": "Rectangle 77",
    width: 2.579,
    height: 5.627,
    transform: "translate(17.61)",
    fill: "#5146af"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_78",
    "data-name": "Rectangle 78",
    width: 2.579,
    height: 5.627,
    transform: "translate(20.545)",
    fill: "#5146af"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_79",
    "data-name": "Rectangle 79",
    width: 2.579,
    height: 5.627,
    transform: "translate(23.48)",
    fill: "#5146af",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_80",
    "data-name": "Rectangle 80",
    width: 2.579,
    height: 5.627,
    transform: "translate(26.415)",
    fill: "#5146af",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_81",
    "data-name": "Rectangle 81",
    width: 2.579,
    height: 5.627,
    transform: "translate(29.35)",
    fill: "#5146af",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_82",
    "data-name": "Rectangle 82",
    width: 2.579,
    height: 5.627,
    transform: "translate(32.285)",
    fill: "#5146af",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_83",
    "data-name": "Rectangle 83",
    width: 2.579,
    height: 5.627,
    transform: "translate(35.22)",
    fill: "#5146af",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_84",
    "data-name": "Rectangle 84",
    width: 2.579,
    height: 5.627,
    transform: "translate(38.155)",
    fill: "#5146af",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_85",
    "data-name": "Rectangle 85",
    width: 2.579,
    height: 5.627,
    transform: "translate(41.09)",
    fill: "#5146af",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_86",
    "data-name": "Rectangle 86",
    width: 2.579,
    height: 5.627,
    transform: "translate(44.025)",
    fill: "#5146af",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_87",
    "data-name": "Rectangle 87",
    width: 56.69,
    height: 6.899,
    fill: "none",
    stroke: "#5146af",
    strokeWidth: 0.75
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_337",
    "data-name": "Group 337",
    transform: "translate(46.292 6.612)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_671",
    "data-name": "Path 671",
    d: "M293.422,172.414a1.282,1.282,0,0,0-1.282,1.282v54.037a1.282,1.282,0,0,0,1.282,1.282h54.126a1.282,1.282,0,0,0,1.282-1.282V190.061l-17.647-17.647H293.422Z",
    transform: "translate(-290.236 -170.51)",
    fill: "#5146af",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_672",
    "data-name": "Path 672",
    d: "M289.191,168.183a1.282,1.282,0,0,0-1.282,1.282V223.5a1.282,1.282,0,0,0,1.282,1.282h54.126A1.282,1.282,0,0,0,344.6,223.5V185.83l-17.647-17.647H289.191Z",
    transform: "translate(-287.909 -168.183)",
    fill: "#004f9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_673",
    "data-name": "Path 673",
    d: "M375.968,185.83h16.364l-17.647-17.647v16.364A1.283,1.283,0,0,0,375.968,185.83Z",
    transform: "translate(-335.642 -168.183)",
    fill: "#004f9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_674",
    "data-name": "Path 674",
    d: "M342.9,215.03l-7.988-8.224h3.05V193.3h9.875v13.507h3.05Z",
    transform: "translate(-313.766 -181.999)",
    fill: "#73b8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_675",
    "data-name": "Path 675",
    d: "M349.452,235.625V246.3h-28.9V235.625H325.2v6.155H344.8v-6.155Z",
    transform: "translate(-305.863 -205.281)",
    fill: "#73b8ff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_676",
    "data-name": "Path 676",
    d: "M363.871,247.8H353.684l26.792-94.309h10.187Z",
    transform: "translate(-277.798 -153.488)",
    opacity: 0.2,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_677",
    "data-name": "Path 677",
    d: "M406.79,247.8H385.177l26.792-94.309h21.613Z",
    transform: "translate(-295.122 -153.488)",
    opacity: 0.2,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_343",
    "data-name": "Group 343",
    transform: "translate(11.686 137.11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_342",
    "data-name": "Group 342",
    transform: "translate(1.359)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_339",
    "data-name": "Group 339",
    transform: "translate(9.129)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_678",
    "data-name": "Path 678",
    d: "M104.727,354.631c1.421-4.893.365-10.17-1.313-14.981a8.258,8.258,0,0,0-1.729-3.205,1.94,1.94,0,0,0-1.667-.684c-.9.183-1.28,1.256-1.381,2.17-.641,5.768,3.16,11.055,4.121,16.779",
    transform: "translate(-98.564 -335.736)",
    fill: "#71afef"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_340",
    "data-name": "Group 340",
    transform: "translate(17.695 8.751)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_679",
    "data-name": "Path 679",
    d: "M119.245,362.873a15,15,0,0,1,1.355-4.207,7.443,7.443,0,0,1,3.01-3.168,1.676,1.676,0,0,1,1.847-.054c.539.479.366,1.361.047,2.008-1.746,3.543-6.206,5.131-7.9,8.7",
    transform: "translate(-117.601 -355.185)",
    fill: "#71afef"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_341",
    "data-name": "Group 341",
    transform: "translate(0 4.689)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_680",
    "data-name": "Path 680",
    d: "M95.553,360.8a30.851,30.851,0,0,0,2.786-6.439,11.892,11.892,0,0,0-.023-6.928c-.236-.684-.822-1.466-1.505-1.23a1.367,1.367,0,0,0-.6.512,11.769,11.769,0,0,0-1.992,5.909,57.158,57.158,0,0,1-.7,6.27,1.763,1.763,0,0,1-.37.852.659.659,0,0,1-.846.133.9.9,0,0,1-.26-.45c-.292-.915-4.831-10.338-8.943-11a3.126,3.126,0,0,0-1.007-.035c-5.156.857,6.46,11.631,6.547,13.235-4.2-3.6-5.093-4.266-7.006-4.611-1.474-.266-4.043,1.042-3.2,2.844.584,1.247,2.044,1.8,3.394,2.073,1.475.294,2.992.389,4.439.8a5.841,5.841,0,0,1,3.607,2.514",
    transform: "translate(-78.274 -346.157)",
    fill: "#71afef"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_681",
    "data-name": "Path 681",
    d: "M82.287,370.138a7.006,7.006,0,0,1,2.246.373,10.9,10.9,0,0,1,21.794.321c0,.275-.013.548-.034.818a6.031,6.031,0,0,1,11.069,4.444,4.329,4.329,0,1,1,2.1,8.113H82.287a7.034,7.034,0,0,1,0-14.069Z",
    transform: "translate(-75.253 -349.045)",
    fill: "#9eceff"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    x2: 263.384,
    transform: "translate(4.798 172.271)",
    fill: "none",
    stroke: "#dfdbf8",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_363",
    "data-name": "Group 363",
    transform: "translate(63.137 71.683)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 20.367,
    cy: 3.099,
    rx: 20.367,
    ry: 3.099,
    transform: "translate(0 109.665)",
    fill: "#9eceff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_362",
    "data-name": "Group 362",
    transform: "translate(4.975)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_344",
    "data-name": "Group 344",
    transform: "translate(14.842 104.521)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_682",
    "data-name": "Path 682",
    d: "M235.493,422.626a10.075,10.075,0,0,1-.616,2.572l.386,2.131,1.221.337,2.809-3.3a15.441,15.441,0,0,0-.1-1.611Z",
    transform: "translate(-234.325 -422.626)",
    fill: "#f9daca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_683",
    "data-name": "Path 683",
    d: "M245.394,432.6a.854.854,0,0,1-.164.132,10.386,10.386,0,0,1-4.01.569,12.3,12.3,0,0,1-3.846-.851c-.665-.26-3.2-.1-3.482-.432s-.146-1.393-.146-1.393a6.521,6.521,0,0,1,.273-3.414c.232-.1.359.742.555,1.011a1.054,1.054,0,0,0,1.438.2c.665-.409.8-1.424,1.588-1.716a2.061,2.061,0,0,1,1.147-.187c.933.419,2.508,2.134,3.541,2.767s2.5,1.011,2.79,1.215.241.764.241.764S245.831,432.095,245.394,432.6Z",
    transform: "translate(-233.651 -424.752)",
    fill: "#004f9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_684",
    "data-name": "Path 684",
    d: "M245.47,437.629a.856.856,0,0,1-.164.132,10.385,10.385,0,0,1-4.01.569,12.3,12.3,0,0,1-3.846-.851c-.665-.26-3.2-.1-3.482-.432s-.146-1.393-.146-1.393a16.514,16.514,0,0,1,3.723.505,9.865,9.865,0,0,0,4.424.924c3,.018,3.427-.792,3.427-.792S245.907,437.128,245.47,437.629Z",
    transform: "translate(-233.727 -429.786)",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_345",
    "data-name": "Group 345",
    transform: "translate(2.634 103.439)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_685",
    "data-name": "Path 685",
    d: "M208.6,420.22a39.282,39.282,0,0,1-.651,4.239l.451,2.489,1.425.394,3.281-3.853s.251-2.511.189-2.46Z",
    transform: "translate(-207.305 -420.22)",
    fill: "#f9daca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_686",
    "data-name": "Path 686",
    d: "M220.232,434.609a1,1,0,0,1-.191.154,12.136,12.136,0,0,1-4.683.665,14.371,14.371,0,0,1-4.491-.994c-.776-.3-3.737-.117-4.066-.5s-.17-1.626-.17-1.626c-.292-1.515.053-3.869.319-3.986s.42.867.648,1.18a1.231,1.231,0,0,0,1.68.229c.776-.478.93-1.664,1.855-2a2.4,2.4,0,0,1,1.339-.218c1.09.489,2.929,2.493,4.135,3.232s2.923,1.18,3.258,1.419.282.893.282.893S220.742,434.025,220.232,434.609Z",
    transform: "translate(-206.518 -424.215)",
    fill: "#004f9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_687",
    "data-name": "Path 687",
    d: "M220.321,440.487a1,1,0,0,1-.191.154,12.134,12.134,0,0,1-4.683.665,14.372,14.372,0,0,1-4.491-.994c-.776-.3-3.737-.117-4.066-.5s-.17-1.627-.17-1.627a19.284,19.284,0,0,1,4.348.59c1.18.282,1.658,1.063,5.167,1.079s4-.925,4-.925S220.831,439.9,220.321,440.487Z",
    transform: "translate(-206.607 -430.093)",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_688",
    "data-name": "Path 688",
    d: "M226.257,214.769a2.4,2.4,0,0,0,.38-3.612c-.841-1.169-.153-1.69-.527-2.633s-.768-.988-.593-1.953,0-1.01-.351-1.448.733-1.233.1-1.935-1.144-.346-1.282-.786c-.253-.806.615-1.053,0-1.734s-.724-.439-1.032-1.448-.2-2.166-.962-3.34a6.443,6.443,0,0,0-1.694-2.2c-1.119-1.01-.556-1.558-1.631-2.524a3.494,3.494,0,0,0-3.943-.408l-.289.163a1.745,1.745,0,0,1-1.5.1,2.29,2.29,0,0,0-1.282-.156c-.988.2-.439.9-1.427,1.361-1.2.561-1.916-.243-2.262,2.058a1.481,1.481,0,0,1-.442.843c-.819.783-1.356.625-1.312,1.95s.768,1.427.439,2.348a16.649,16.649,0,0,0-1.141,2.432c-.285,1.168.461.86.4,1.958s-.636,1.119-.022,1.865.812.944.593,1.6-.746,1.185-.7,1.822.4.548-.328,1.624a6.658,6.658,0,0,0-.418,4.763",
    transform: "translate(-202.926 -190.32)",
    fill: "#003051"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_689",
    "data-name": "Path 689",
    d: "M208.223,293.73s19.01,3.95,17.561-.527a19.081,19.081,0,0,1-.938-7.912l-15.218-.516c.016.237.027.474.037.711a21.124,21.124,0,0,1-.574,5.5A17.539,17.539,0,0,1,208.223,293.73Z",
    transform: "translate(-204.822 -242.277)",
    fill: "#f9daca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_690",
    "data-name": "Path 690",
    d: "M210.154,291.854c4.051-.535,4.051-4.814,4.051-4.814l-1.58-.242-1.9-.442A21.12,21.12,0,0,1,210.154,291.854Z",
    transform: "translate(-205.884 -243.146)",
    fill: "#f4ccba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_691",
    "data-name": "Path 691",
    d: "M211.5,236.2s-3.211.876-6.519,2.193c0,0,2.107,6.079.729,10.132,0,0,2.188,7.863,1.783,10.618,0,0,5.792,2.149,15.888.042,0,0,.242-9.059,1.519-11.248,0,0-1.763-6.079,0-10.4l-7.441-1.5",
    transform: "translate(-203.039 -215.474)",
    fill: "#4e9dee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_692",
    "data-name": "Path 692",
    d: "M205.391,310.069c.109,3.78,1.341,17.1,1.777,20.492-.71,6.243-.311,24.913-.311,24.913,3.986,1.268,6.179.518,6.179.518s1.907-19.121,2.8-24.7c.327-3.5,0-18.21,0-18.21,1.039,3.391,4.906,17.014,4.906,17.014s-.532,2.956-.8,4.74c-.8,5.378-1.914,20.744-1.914,20.744,2.452,1.375,6.35,1.043,6.35,1.043s5.087-24.561,5.087-26.97c0-2.038-.89-7.978-.89-7.992-.5-8.5-3.984-18.506-4.434-19.985-3.372.346-11.672,1.01-17.154-.185A22.553,22.553,0,0,0,205.391,310.069Z",
    transform: "translate(-203.261 -251.47)",
    fill: "#004f9f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_357",
    "data-name": "Group 357",
    transform: "translate(2.659 50.631)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_347",
    "data-name": "Group 347",
    transform: "translate(1.237)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_346",
    "data-name": "Group 346"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_693",
    "data-name": "Path 693",
    d: "M226.146,302.956c-2.1.082-4.183.563-6.29.675a41.45,41.45,0,0,1-4.567.009,33.248,33.248,0,0,1-3.54-.381,9.759,9.759,0,0,0-2.327-.4.1.1,0,0,0-.05.187,6.563,6.563,0,0,0,2.284.55,29.6,29.6,0,0,0,3.5.376,37.866,37.866,0,0,0,4.872-.093,27.1,27.1,0,0,0,6.118-.915.005.005,0,0,0,0-.01Z",
    transform: "translate(-209.323 -302.852)",
    fill: "#2b269b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_349",
    "data-name": "Group 349",
    transform: "translate(11.168 1.479)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_348",
    "data-name": "Group 348"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_694",
    "data-name": "Path 694",
    d: "M231.4,306.169c-.018,2.336.195,4.658.03,7-.006.093.138.092.144,0a41.8,41.8,0,0,0-.111-7,.032.032,0,0,0-.063,0Z",
    transform: "translate(-231.395 -306.138)",
    fill: "#2b269b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_351",
    "data-name": "Group 351",
    transform: "translate(9.863 8.457)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_350",
    "data-name": "Group 350"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_695",
    "data-name": "Path 695",
    d: "M229.89,321.651c-.441.171-.946.214-1.368.428a.058.058,0,0,0,.029.108,2.857,2.857,0,0,0,1.374-.452c.042-.026.015-.1-.035-.084Z",
    transform: "translate(-228.494 -321.648)",
    fill: "#2b269b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_352",
    "data-name": "Group 352",
    transform: "translate(9.825 0.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_696",
    "data-name": "Path 696",
    d: "M228.861,305.081s-.105,3.2-.211,6.392c-.045,1.6-.08,3.2-.092,4.4s0,2,0,2-.043-.8-.07-2-.05-2.8-.062-4.4c-.007-3.2-.014-6.4-.014-6.4Z",
    transform: "translate(-228.411 -305.072)",
    fill: "#2b269b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_354",
    "data-name": "Group 354",
    transform: "translate(15.029 0.494)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_353",
    "data-name": "Group 353"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_697",
    "data-name": "Path 697",
    d: "M244.258,307.48a4.3,4.3,0,0,1-2.967-1.086,4.976,4.976,0,0,1-1.146-2.384.087.087,0,0,0-.169.023c-.048,2.237,2.261,3.725,4.282,3.465a.009.009,0,0,0,0-.018Z",
    transform: "translate(-239.975 -303.949)",
    fill: "#2b269b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_356",
    "data-name": "Group 356",
    transform: "translate(0 0.612)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_355",
    "data-name": "Group 355"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_698",
    "data-name": "Path 698",
    d: "M206.582,307.761c2.022.261,4.33-1.227,4.282-3.465a.087.087,0,0,0-.169-.023,4.913,4.913,0,0,1-1.146,2.384,4.317,4.317,0,0,1-2.967,1.086.009.009,0,0,0,0,.018Z",
    transform: "translate(-206.573 -304.213)",
    fill: "#2b269b"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_699",
    "data-name": "Path 699",
    d: "M246.565,239.385s1.846.337,2.332,5.248c.348,3.515-1.291,17.02-1.291,17.02a6.76,6.76,0,0,1-2.621-3.471c-.593-2.173.033-5.827-.23-7.407a36.977,36.977,0,0,1-.358-6.3C244.486,242.766,244.746,240.423,246.565,239.385Z",
    transform: "translate(-224.708 -217.309)",
    fill: "#f9daca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_700",
    "data-name": "Path 700",
    d: "M217.167,230.682a4.891,4.891,0,0,0,4.425,2.07,6.094,6.094,0,0,0,4.425-2.154l-.311-.068a1.868,1.868,0,0,1-1.438-1.417c-.042-.184-.079-.358-.116-.527-.247-1.2-.327-1.917-.327-1.917l-1.191-.279-3.945-.932a8.284,8.284,0,0,1,.095,3.84,1.834,1.834,0,0,1-1.259,1.28Z",
    transform: "translate(-209.742 -209.648)",
    fill: "#f9daca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_701",
    "data-name": "Path 701",
    d: "M222.447,227.383a16.6,16.6,0,0,0,4.609,2.212c-.247-1.2-.327-1.917-.327-1.917l-1.191-.279-.99-.105Z",
    transform: "translate(-212.646 -210.658)",
    fill: "#e2bdac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_702",
    "data-name": "Path 702",
    d: "M223.844,199.067s1.581,6.322.851,8.754-1.824,4.073-2.493,4.346-5.805-1.824-6.383-2.462-3.07-6.565-2.644-9.088S221.352,194.143,223.844,199.067Z",
    transform: "translate(-207.519 -193.839)",
    fill: "#f9daca"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_358",
    "data-name": "Group 358",
    transform: "translate(6.511 19.185)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_88",
    "data-name": "Rectangle 88",
    width: 34.427,
    height: 34.427,
    transform: "translate(0 3.505) rotate(-5.843)",
    fill: "#003469"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_89",
    "data-name": "Rectangle 89",
    width: 31.203,
    height: 27.002,
    transform: "translate(1.759 4.852) rotate(-5.843)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_98",
    "data-name": "Rectangle 98",
    width: 16.89,
    height: 1.778,
    transform: "matrix(0.995, -0.105, 0.105, 0.995, 9.531, 9.583)",
    fill: "#73b8ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_101",
    "data-name": "Rectangle 101",
    width: 16.89,
    height: 1.778,
    transform: "matrix(-0.995, 0.105, -0.105, -0.995, 27.403, 21.938)",
    fill: "#73b8ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_99",
    "data-name": "Rectangle 99",
    width: 16.001,
    height: 1.778,
    transform: "matrix(0.995, -0.105, 0.105, 0.995, 10.415, 13.935)",
    fill: "#73b8ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_100",
    "data-name": "Rectangle 100",
    width: 16.001,
    height: 1.778,
    transform: "matrix(-0.995, 0.105, -0.105, -0.995, 26.519, 17.586)",
    fill: "#73b8ff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_706",
    "data-name": "Path 706",
    d: "M202.612,241.264s-2.634,1.712-1.778,7.045,1.646,10.337,1.778,11.983,1.185,6.189,3.028,5.86,2.535-2.634,2.667-3.852-.362-4.247-.23-4.576,1.458-1.415,1.623-1.975,2.029.219,2.457-3.238c0,0,1.874.474,2.466-.283s-2.3-1.322-3.029-1.531a18.188,18.188,0,0,0-4.241-.134c-.362.082-.428,1.1-.609,2.058s-.829,3.117-.829,3.117l-.954-6.442S205.18,242.954,202.612,241.264Z",
    transform: "translate(-200.663 -218.343)",
    fill: "#f9daca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_707",
    "data-name": "Path 707",
    d: "M289,254.145a1.728,1.728,0,0,1-.829-.138.041.041,0,0,0-.016-.005c-.675-.271-1.382-1.435-1.382-1.435a4.349,4.349,0,0,1-2.131-1.058,1.63,1.63,0,0,1,.154-2.822,7.309,7.309,0,0,1,3.242-.548c.893.027.962.282,1.478,2.052v.01C289.951,252.959,289.383,254.081,289,254.145Z",
    transform: "translate(-246.45 -222.121)",
    fill: "#f9daca"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_359",
    "data-name": "Group 359",
    transform: "translate(4.193 34.279)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_708",
    "data-name": "Path 708",
    d: "M211.87,266.508s-.092.479-.252,1.191c-.085.355-.173.772-.284,1.214l-.344,1.387-.365,1.381-.327,1.2-.231.851c-.053.207-.083.324-.083.324s.046-.487.191-1.2c.075-.358.154-.777.261-1.221s.222-.917.337-1.39l.373-1.38c.12-.44.248-.847.351-1.2C211.709,266.968,211.87,266.508,211.87,266.508Z",
    transform: "translate(-209.983 -266.508)",
    fill: "#dda692"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_709",
    "data-name": "Path 709",
    d: "M221.592,196.606s.484,2.049,1.274,2.411,1.441-.1,1.84.4.662,1.646,1.452,1.415,1.482-.5,1.844.03.494,2.011,2.141,2.11c1.311.079-.66-3.259-.66-3.259s-1.152-1.836-1.317-1.972-1.243-1.423-1.307-1.456a10.3,10.3,0,0,0-1.756-.355c-.26.033-1.975,0-1.975,0Z",
    transform: "translate(-212.176 -193.402)",
    fill: "#003051"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_710",
    "data-name": "Path 710",
    d: "M217.345,198.429s.583,1.423-.461,2.157a5.017,5.017,0,0,0-1.542,3.031c.062.944.325,1.075.193,1.6a1.78,1.78,0,0,1-2.371,1.507c-.326-.063-.021-1.946-.021-2.077s-.528-1.961-.506-2.312-.2-2.655.394-3.117,2.086-.944,2.174-1.075a10.72,10.72,0,0,1,1.448-.7",
    transform: "translate(-207.237 -194.237)",
    fill: "#003051"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_360",
    "data-name": "Group 360",
    transform: "translate(1.924 6.249)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_711",
    "data-name": "Path 711",
    d: "M206.6,204.208c-.529,1.068-.076,2.177-.716,3.3a4.089,4.089,0,0,0-.939,2.215c.031.408.263.63.392,1,.384,1.087-.135,1.385,0,2.249s1.178,1.632,1.767,2.215c.054.054.129-.026.082-.082a13.449,13.449,0,0,1-1.325-1.488c-.678-1.159-.219-1.04-.138-1.923.057-.612-.229-.791-.427-1.338-.59-1.63.651-2.233,1.085-3.492a18.834,18.834,0,0,0,.225-2.658Z",
    transform: "translate(-204.939 -204.208)",
    fill: "#383493"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_361",
    "data-name": "Group 361",
    transform: "translate(18.8 6.31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_712",
    "data-name": "Path 712",
    d: "M242.457,204.37a2.441,2.441,0,0,1,1.478,1.3,6.986,6.986,0,0,1,.135,1.051,1.837,1.837,0,0,0,.263.686c.3.418.84.557,1.02,1.087a10.919,10.919,0,0,1,.1,2.449.035.035,0,0,0,.071,0,7.12,7.12,0,0,0-.024-2.49c-.3-.9-1.023-.89-1.28-2.1-.22-1.04-.446-2.036-1.762-2.007a.012.012,0,0,0,0,.024Z",
    transform: "translate(-242.448 -204.345)",
    fill: "#383493"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_372",
    "data-name": "Group 372",
    transform: "translate(185.229 63.499)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 24.944,
    cy: 3.099,
    rx: 24.944,
    ry: 3.099,
    transform: "translate(8.088 117.849)",
    fill: "#9eceff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_371",
    "data-name": "Group 371"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_364",
    "data-name": "Group 364",
    transform: "translate(24.048 3.295)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_713",
    "data-name": "Path 713",
    d: "M529.908,205.655l-7.364.27a13.51,13.51,0,0,1,.005,2.188,11.769,11.769,0,0,1-.182,1.43,6.735,6.735,0,0,1-.457,1.546,1.347,1.347,0,0,1-1.36.526s.083,2.167,3.456,2.562c3.275.383,4.31-1.261,4.31-1.261a1.34,1.34,0,0,1-.107-.083,1.836,1.836,0,0,1-.611-1.031C527.554,211.593,528.456,207.421,529.908,205.655Z",
    transform: "translate(-517.789 -193.866)",
    fill: "#fbab99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_714",
    "data-name": "Path 714",
    d: "M529.76,208.817c-1.534,1.428-4.324,2.029-5.172,2.179a11.746,11.746,0,0,0,.182-1.43C527.1,208.8,531.067,207.594,529.76,208.817Z",
    transform: "translate(-520.01 -195.317)",
    fill: "#ef998b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_715",
    "data-name": "Path 715",
    d: "M518.507,183.089a5.86,5.86,0,0,0-.557,1.258c-.673,2.062-2.908,9.376-1.174,10.43,2.023,1.23,5.7.285,7.569-.684,3.553-1.841,4.636-2.313,5.1-6.295C530.091,182.271,521.632,178,518.507,183.089Z",
    transform: "translate(-515.358 -180.201)",
    fill: "#fbab99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_716",
    "data-name": "Path 716",
    d: "M514.412,181.225a7.718,7.718,0,0,0,8.75,2.866,4.113,4.113,0,0,0-.682,2.532,13.4,13.4,0,0,1,.544,2.726l.6-.1s.642-1.7,2.074-1-.347,4.344-.033,4.433,2.306-1.8,3.4-4.4,1.355-4.593-1.189-5.471a4.564,4.564,0,0,0-3.02-3.2C522.329,178.819,514.412,181.225,514.412,181.225Z",
    transform: "translate(-514.412 -179.453)",
    fill: "#003051"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_365",
    "data-name": "Group 365",
    transform: "translate(14.57 111.617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_717",
    "data-name": "Path 717",
    d: "M514.858,420.206a37.381,37.381,0,0,0,.62,4.043l-.43,2.374-1.359.375-3.129-3.675s.046-2.542.105-2.493Z",
    transform: "translate(-502.816 -420.206)",
    fill: "#f9daca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_718",
    "data-name": "Path 718",
    d: "M493.545,433.929a.953.953,0,0,0,.183.147,11.568,11.568,0,0,0,4.466.634,13.711,13.711,0,0,0,4.284-.948c.74-.289,3.564-.112,3.878-.481s.162-1.551.162-1.551c.279-1.445-.051-3.691-.3-3.8s-.4.827-.619,1.125a1.173,1.173,0,0,1-1.6.218c-.74-.456-.887-1.587-1.769-1.911a2.292,2.292,0,0,0-1.277-.208c-1.039.467-2.793,2.378-3.944,3.082s-2.788,1.125-3.108,1.353-.269.852-.269.852S493.058,433.371,493.545,433.929Z",
    transform: "translate(-493.348 -424.015)",
    fill: "#004f9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_719",
    "data-name": "Path 719",
    d: "M493.545,439.536a.956.956,0,0,0,.183.147,11.569,11.569,0,0,0,4.466.634,13.711,13.711,0,0,0,4.284-.948c.74-.289,3.564-.112,3.878-.481s.162-1.551.162-1.551a18.386,18.386,0,0,0-4.147.563c-1.125.269-1.581,1.014-4.928,1.029s-3.817-.882-3.817-.882S493.058,438.979,493.545,439.536Z",
    transform: "translate(-493.348 -429.622)",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_366",
    "data-name": "Group 366",
    transform: "translate(39.502 109.197)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_720",
    "data-name": "Path 720",
    d: "M564.961,414.829a37.477,37.477,0,0,0,1.586,3.77l.161,2.407-1.227.695-3.93-2.8s-.574-2.476-.5-2.443Z",
    transform: "translate(-555.516 -414.829)",
    fill: "#f9daca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_721",
    "data-name": "Path 721",
    d: "M549.131,431.72a.951.951,0,0,0,.213.1,11.559,11.559,0,0,0,4.486-.473,13.7,13.7,0,0,0,3.924-1.963c.648-.461,3.429-.976,3.644-1.411s-.22-1.544-.22-1.544c-.081-1.469-.948-3.567-1.221-3.614s-.187.9-.326,1.242a1.174,1.174,0,0,1-1.5.6c-.829-.262-1.247-1.323-2.181-1.423a2.291,2.291,0,0,0-1.289.109c-.895.705-2.13,2.986-3.075,3.95s-2.431,1.77-2.685,2.069-.053.891-.053.891S548.524,431.3,549.131,431.72Z",
    transform: "translate(-548.761 -419.22)",
    fill: "#004f9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_722",
    "data-name": "Path 722",
    d: "M549.131,436.14a.951.951,0,0,0,.213.1,11.559,11.559,0,0,0,4.486-.473,13.7,13.7,0,0,0,3.924-1.963c.648-.461,3.429-.976,3.644-1.411s-.22-1.544-.22-1.544a18.4,18.4,0,0,0-3.885,1.555c-1.026.535-1.287,1.369-4.529,2.2s-3.917.074-3.917.074S548.523,435.717,549.131,436.14Z",
    transform: "translate(-548.761 -423.64)",
    fill: "#002346"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_368",
    "data-name": "Group 368"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_367",
    "data-name": "Group 367"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_723",
    "data-name": "Path 723",
    d: "M460.965,173.518c.01-.308.414-.189.535.055a1.746,1.746,0,0,1,.072.213c-.074-.5-.128-.909-.125-1.011.009-.292.382-.211.523.006-.023-.2-.037-.355-.036-.42.005-.374.413-.25.538.049a4.376,4.376,0,0,1,.128.508,2.591,2.591,0,0,1-.024-.282c.01-.308.367-.256.487-.011a3.913,3.913,0,0,1,.151.584c.07.3.182.625.246.931.058.277.495,1.569,1.161,1.655,1.02.132.241-1.56.916-2.01.212-.141.559,1.192.639,1.956a8.5,8.5,0,0,1,.081,1.6,10.626,10.626,0,0,0-.164,1.384,5.676,5.676,0,0,0,.68,1.295l-2.486.786a10.238,10.238,0,0,0-1.047-1.641,5.808,5.808,0,0,1-1.758-2.587,11.269,11.269,0,0,1-.459-2.026S460.962,173.619,460.965,173.518Z",
    transform: "translate(-460.965 -172.13)",
    fill: "#ffb6ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_724",
    "data-name": "Path 724",
    d: "M489.868,201.323a103.122,103.122,0,0,1-12.828-4.612c-3.883-4.588-7.692-9.705-7.984-10.185-.663.319-2.079,1.113-2.079,1.113s5.4,10.643,7.39,12.844c2.268,1.894,5.582,6.038,13.186,7.332C490.78,203.426,489.868,201.323,489.868,201.323Z",
    transform: "translate(-464.271 -180.05)",
    fill: "#ffb6ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_725",
    "data-name": "Path 725",
    d: "M505.646,325.661c-.465-6.074,1.636-25.116,1.841-26.754s1.357-1.847,2.237-2.116c4.393-1.321,9.6,5.492,8.215,11.611-.019.1.661.68.633.785-.826,3.544-4.159,15.538-4.768,17.7,2.037,7.7-.03,20.985-.9,26.989a21.918,21.918,0,0,1-5.7-.231S506.111,331.734,505.646,325.661Z",
    transform: "translate(-485.506 -240.611)",
    fill: "#004f9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_726",
    "data-name": "Path 726",
    d: "M510.178,284.939a20.85,20.85,0,0,0,4.993.326c4.221-.111,9.575-2.247,9.575-2.247,5.385,5.828,2.425,12.652,2.611,14.9s1.262,13.626,1.744,19.566c5.187,7.781,8.276,25.908,8.295,25.993a15.137,15.137,0,0,1-5.241,1.6s-9.35-19.62-11.219-25.131c-1.7-5-6.078-20.176-6.159-20.162l-5.586.956A107.426,107.426,0,0,1,510.178,284.939Z",
    transform: "translate(-487.492 -233.126)",
    fill: "#004f9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_727",
    "data-name": "Path 727",
    d: "M527.834,255.474c-1.052.2-2.076.348-3.078.467a50.517,50.517,0,0,1-16.633-.571s-.808-23.068,2.723-35.327c.634-2.208,1.762-2.654,3.963-2.452,2,3.536,6.073.519,6.073.519a35.109,35.109,0,0,1,5.663,3.077c.856.71-.656,11-.279,16.825C526.517,241.88,527.3,252.09,527.834,255.474Z",
    transform: "translate(-486.861 -197.113)",
    fill: "#4e9dee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_728",
    "data-name": "Path 728",
    d: "M506.321,215.2s-5.429-1.273-8.567-2.05c-2.415,2.818-2.144,7.36-2.144,7.36s5.025,3.194,8.7,3.5A51.394,51.394,0,0,1,506.321,215.2Z",
    transform: "translate(-480.017 -194.693)",
    fill: "#4e9dee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_729",
    "data-name": "Path 729",
    d: "M505.624,219.413a17.662,17.662,0,0,0-3.007,7.733,22.409,22.409,0,0,1-7-3.192c1.115.361,5.874,2.131,6.526.665A22.681,22.681,0,0,1,505.624,219.413Z",
    transform: "translate(-480.028 -198.139)",
    fill: "#004f9f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_369",
    "data-name": "Group 369",
    transform: "translate(26.57 64.175)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_730",
    "data-name": "Path 730",
    d: "M520.019,314.764l.3.893c.184.571.465,1.382.772,2.363s.681,2.121,1.051,3.352l1.168,3.853,1.127,3.864c.366,1.231.677,2.39.966,3.376l.946,3.294-.348-.877c-.205-.564-.513-1.366-.84-2.341s-.718-2.111-1.1-3.339l-1.185-3.85-1.112-3.871c-.354-1.236-.65-2.4-.92-3.391s-.464-1.828-.613-2.409S520.019,314.764,520.019,314.764Z",
    transform: "translate(-520.019 -314.764)",
    fill: "#2b269b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_370",
    "data-name": "Group 370",
    transform: "translate(19.769 28.503)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_90",
    "data-name": "Rectangle 90",
    width: 31.678,
    height: 31.678,
    transform: "translate(2.493 0) rotate(4.514)",
    fill: "#004f9f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_91",
    "data-name": "Rectangle 91",
    width: 28.711,
    height: 24.846,
    transform: "translate(3.862 1.511) rotate(4.514)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_404",
    "data-name": "Group 404",
    transform: "translate(7.343 8.165)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_102",
    "data-name": "Rectangle 102",
    width: 17.331,
    height: 1.824,
    transform: "translate(2.185 0) rotate(7)",
    fill: "#73b8ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_103",
    "data-name": "Rectangle 103",
    width: 17.331,
    height: 1.824,
    transform: "translate(17.202 16.479) rotate(-173)",
    fill: "#73b8ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_104",
    "data-name": "Rectangle 104",
    width: 16.419,
    height: 1.824,
    transform: "translate(2.065 4.555) rotate(7)",
    fill: "#73b8ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_105",
    "data-name": "Rectangle 105",
    width: 16.419,
    height: 1.824,
    transform: "translate(17.322 11.924) rotate(-173)",
    fill: "#73b8ff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_734",
    "data-name": "Path 734",
    d: "M542.76,247.691s2.478,7.559,3.023,8.315,3.486.84,3.779-.924-.924-8.357-.924-8.357",
    transform: "translate(-505.958 -213.163)",
    fill: "#fbab99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_735",
    "data-name": "Path 735",
    d: "M542.515,224.971s2.913,3.146,3.921,11.041a22.108,22.108,0,0,1-6.467,1.071,18.422,18.422,0,0,1-2.73-6.871C536.357,225.821,539.161,223.232,542.515,224.971Z",
    transform: "translate(-502.831 -200.896)",
    fill: "#499aee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_736",
    "data-name": "Path 736",
    d: "M545.547,262.614s-.742,8.1-1.307,13.753a30.647,30.647,0,0,1-.629,4.137,2.575,2.575,0,0,0,2.129.436s4.637-14.2,4.337-17.948",
    transform: "translate(-506.426 -221.903)",
    fill: "#fbab99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_737",
    "data-name": "Path 737",
    d: "M541.325,300.712a14.756,14.756,0,0,1-1.16,1.059,6.2,6.2,0,0,0-1.01,1.509c-.014.093.368.149.6,0s.9-.8,1-.847,1.245-.038,1.475-.662",
    transform: "translate(-503.975 -242.859)",
    fill: "#fbab99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_738",
    "data-name": "Path 738",
    d: "M542.724,301.511s-.5,1.307-.665,1.706-.774.726-.786.9a5.02,5.02,0,0,0,2.806.61c.777-.086,1.253-1.325,1.113-2.449-.058-.468-.557-1.113-.281-1.844",
    transform: "translate(-505.14 -242.704)",
    fill: "#fbab99"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_403",
    "data-name": "Group 403",
    transform: "translate(24.966 13.801)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_379",
    "data-name": "Group 379",
    transform: "translate(0 53.979)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_759",
    "data-name": "Path 759",
    d: "M105.6,195.751h31.464l-3.63-2.686V182.477a.829.829,0,0,0-.829-.829H105.6a.829.829,0,0,0-.829.829v12.446A.83.83,0,0,0,105.6,195.751Z",
    transform: "translate(-104.769 -181.648)",
    fill: "#fff",
    stroke: "#73b8ff",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_92",
    "data-name": "Rectangle 92",
    width: 14.404,
    height: 1.378,
    transform: "translate(16.166 3.522) rotate(180)",
    fill: "#a4a4f7",
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_93",
    "data-name": "Rectangle 93",
    width: 14.404,
    height: 1.378,
    transform: "translate(16.166 5.58) rotate(180)",
    fill: "#a4a4f7",
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_94",
    "data-name": "Rectangle 94",
    width: 14.404,
    height: 1.378,
    transform: "translate(16.166 7.639) rotate(180)",
    fill: "#a4a4f7",
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_95",
    "data-name": "Rectangle 95",
    width: 14.404,
    height: 1.378,
    transform: "translate(16.166 9.645) rotate(180)",
    fill: "#a4a4f7",
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_96",
    "data-name": "Rectangle 96",
    width: 10.045,
    height: 1.378,
    transform: "translate(11.808 12.045) rotate(180)",
    fill: "#a4a4f7",
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_378",
    "data-name": "Group 378",
    transform: "translate(17.242 2.058)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_760",
    "data-name": "Path 760",
    d: "M152.976,186.507v9.415a.288.288,0,0,1-.288.288h-9.313a.287.287,0,0,1-.284-.288v-9.415a.286.286,0,0,1,.284-.284h9.313A.286.286,0,0,1,152.976,186.507Z",
    transform: "translate(-143.091 -186.223)",
    fill: "#a4a4f7",
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_761",
    "data-name": "Path 761",
    d: "M159.062,200.919v1.765a.288.288,0,0,1-.288.288h-4.619l.2-2.052,2.174-2.4Z",
    transform: "translate(-149.177 -192.984)",
    fill: "#004f9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_762",
    "data-name": "Path 762",
    d: "M151.683,201.738h-8.308a.287.287,0,0,1-.284-.288v-1.765l3.251-3.412Z",
    transform: "translate(-143.091 -191.752)",
    fill: "#004f9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_763",
    "data-name": "Path 763",
    d: "M159.353,190.825a1.146,1.146,0,1,1-1.146-1.146A1.146,1.146,0,0,1,159.353,190.825Z",
    transform: "translate(-150.775 -188.124)",
    fill: "#004f9f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_400",
    "data-name": "Group 400",
    transform: "translate(12.436 20.727)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_399",
    "data-name": "Group 399"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_380",
    "data-name": "Group 380",
    transform: "translate(185.946 15.251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_764",
    "data-name": "Path 764",
    d: "M550.521,145.072a2.505,2.505,0,1,1-1.4-3.255A2.505,2.505,0,0,1,550.521,145.072Z",
    transform: "translate(-545.688 -141.637)",
    fill: "#73b8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_765",
    "data-name": "Path 765",
    d: "M548.885,146.542l.562,1.254,1.883-1.164",
    transform: "translate(-547.446 -144.335)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.056
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_381",
    "data-name": "Group 381",
    transform: "translate(23.899 9.606)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_766",
    "data-name": "Path 766",
    d: "M190.414,130.818a2.506,2.506,0,1,1-3.161-1.6A2.505,2.505,0,0,1,190.414,130.818Z",
    transform: "translate(-185.527 -129.092)",
    fill: "#73b8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_767",
    "data-name": "Path 767",
    d: "M188.85,133.841l1.236.6.7-2.1",
    transform: "translate(-187.355 -130.88)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.056
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_382",
    "data-name": "Group 382",
    transform: "translate(214.366 66.669)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_768",
    "data-name": "Path 768",
    d: "M616.506,260.031a3.832,3.832,0,1,1-3.54-4.1A3.831,3.831,0,0,1,616.506,260.031Z",
    transform: "translate(-608.852 -255.918)",
    fill: "#73b8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_769",
    "data-name": "Path 769",
    d: "M613.6,263.34l1.4,1.57,2.21-2.565",
    transform: "translate(-611.465 -259.453)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.615
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_770",
    "data-name": "Path 770",
    d: "M597.483,263.005a.921.921,0,1,1-.921-.921A.921.921,0,0,1,597.483,263.005Z",
    transform: "translate(-387.218 -192.641)",
    fill: "#73b8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_771",
    "data-name": "Path 771",
    d: "M528.532,122.164a.921.921,0,1,1-.921-.921A.921.921,0,0,1,528.532,122.164Z",
    transform: "translate(-349.291 -115.168)",
    fill: "#73b8ff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_772",
    "data-name": "Path 772",
    d: "M164.312,234.6a1.47,1.47,0,1,1-1.47-1.47A1.47,1.47,0,0,1,164.312,234.6Z",
    transform: "translate(-148.34 -176.715)",
    fill: "#73b8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_773",
    "data-name": "Path 773",
    d: "M484.924,117.253a2.262,2.262,0,1,1-2.261-2.262A2.262,2.262,0,0,1,484.924,117.253Z",
    transform: "translate(-323.829 -111.729)",
    fill: "#73b8ff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_774",
    "data-name": "Path 774",
    d: "M138.858,270.91a2.262,2.262,0,1,1-2.261-2.262A2.262,2.262,0,0,1,138.858,270.91Z",
    transform: "translate(-133.468 -196.252)",
    fill: "#73b8ff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_775",
    "data-name": "Path 775",
    d: "M340.171,118.22a1.47,1.47,0,1,1-1.47-1.47A1.47,1.47,0,0,1,340.171,118.22Z",
    transform: "translate(-245.075 -112.697)",
    fill: "#73b8ff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_776",
    "data-name": "Path 776",
    d: "M370.095,139.84a1.47,1.47,0,1,1-1.47-1.47A1.47,1.47,0,0,1,370.095,139.84Z",
    transform: "translate(-261.535 -124.59)",
    fill: "#73b8ff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_777",
    "data-name": "Path 777",
    d: "M421.079,121.488a1.47,1.47,0,1,1-1.47-1.47A1.47,1.47,0,0,1,421.079,121.488Z",
    transform: "translate(-289.58 -114.495)",
    fill: "#73b8ff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_386",
    "data-name": "Group 386",
    transform: "translate(0 52.094)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_385",
    "data-name": "Group 385"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_383",
    "data-name": "Group 383",
    transform: "translate(1.036)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_778",
    "data-name": "Path 778",
    d: "M135.006,226.185a.294.294,0,0,1-.294-.294v-2.073a.294.294,0,1,1,.588,0v2.073A.294.294,0,0,1,135.006,226.185Z",
    transform: "translate(-134.712 -223.525)",
    fill: "#73b8ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_384",
    "data-name": "Group 384",
    transform: "translate(0 1.036)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_779",
    "data-name": "Path 779",
    d: "M134.776,226.416H132.7a.294.294,0,1,1,0-.588h2.073a.294.294,0,1,1,0,.588Z",
    transform: "translate(-132.409 -225.828)",
    fill: "#73b8ff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_390",
    "data-name": "Group 390",
    transform: "translate(16.265)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_389",
    "data-name": "Group 389"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_387",
    "data-name": "Group 387",
    transform: "translate(1.036)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_780",
    "data-name": "Path 780",
    d: "M171.156,110.4a.294.294,0,0,1-.294-.294v-2.073a.294.294,0,1,1,.588,0v2.073A.293.293,0,0,1,171.156,110.4Z",
    transform: "translate(-170.862 -107.742)",
    fill: "#73b8ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_388",
    "data-name": "Group 388",
    transform: "translate(0 1.036)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_781",
    "data-name": "Path 781",
    d: "M170.926,110.633h-2.073a.294.294,0,1,1,0-.588h2.073a.294.294,0,0,1,0,.588Z",
    transform: "translate(-168.559 -110.045)",
    fill: "#73b8ff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_394",
    "data-name": "Group 394",
    transform: "translate(188.727 24.809)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_393",
    "data-name": "Group 393"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_391",
    "data-name": "Group 391",
    transform: "translate(1.037)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_782",
    "data-name": "Path 782",
    d: "M554.466,165.541a.294.294,0,0,1-.294-.294v-2.073a.294.294,0,1,1,.588,0v2.073A.294.294,0,0,1,554.466,165.541Z",
    transform: "translate(-554.172 -162.881)",
    fill: "#73b8ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_392",
    "data-name": "Group 392",
    transform: "translate(0 1.036)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_783",
    "data-name": "Path 783",
    d: "M554.235,165.772h-2.073a.294.294,0,1,1,0-.588h2.073a.294.294,0,1,1,0,.588Z",
    transform: "translate(-551.868 -165.184)",
    fill: "#73b8ff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_398",
    "data-name": "Group 398",
    transform: "translate(68.634 6.455)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_397",
    "data-name": "Group 397"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_395",
    "data-name": "Group 395",
    transform: "translate(1.036)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_784",
    "data-name": "Path 784",
    d: "M287.549,124.748a.294.294,0,0,1-.294-.294v-2.073a.294.294,0,0,1,.588,0v2.073A.294.294,0,0,1,287.549,124.748Z",
    transform: "translate(-287.255 -122.088)",
    fill: "#73b8ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_396",
    "data-name": "Group 396",
    transform: "translate(0 1.037)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_785",
    "data-name": "Path 785",
    d: "M287.319,124.98h-2.073a.294.294,0,0,1,0-.588h2.073a.294.294,0,1,1,0,.588Z",
    transform: "translate(-284.952 -124.392)",
    fill: "#73b8ff"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_401",
    "data-name": "Group 401",
    transform: "translate(82.459 11.601)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_787",
    "data-name": "Path 787",
    d: "M309.826,88.028v9.217a.623.623,0,0,1-.121.373.635.635,0,0,1-.529.277h-13.54a.665.665,0,0,1-.449-.176V89.161a.568.568,0,0,1,.57-.564h9.514a.568.568,0,0,0,.564-.57.568.568,0,0,1,.564-.57h2.857A.572.572,0,0,1,309.826,88.028Z",
    transform: "translate(-291.971 -87.458)",
    fill: "#004f9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_788",
    "data-name": "Path 788",
    d: "M305.774,100.531a.635.635,0,0,1-.529.277H291.7a.665.665,0,0,1-.449-.176.632.632,0,0,1-.136-.192.184.184,0,0,1-.02-.045l-3.014-6.879a.544.544,0,0,1,.5-.761H302.01a.542.542,0,0,1,.5.323l2.822,6.44Z",
    transform: "translate(-288.04 -90.372)",
    fill: "#004f9f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_789",
    "data-name": "Path 789",
    d: "M202.28,69.178c-.016-.073-.031-.151-.052-.224a7.051,7.051,0,0,0-.244-.878,7.736,7.736,0,0,0-.909-1.819l.889-.883-2.125-2.125-.041.041-.842.847a7.9,7.9,0,0,0-2.921-1.211V61.675h-3v1.252a7.9,7.9,0,0,0-2.921,1.211l-.883-.889L187.1,65.375l.889.883a7.9,7.9,0,0,0-1.211,2.92h-1.252v3h1.258a7.8,7.8,0,0,0,1.205,2.92l-.889.883,2.125,2.125.883-.889a7.8,7.8,0,0,0,2.921,1.205v1.258h3V78.428a7.8,7.8,0,0,0,2.921-1.205l.842.847.041.041,1.278-1.278.847-.847-.847-.842-.041-.041c.016-.021.026-.041.041-.063a7.777,7.777,0,0,0,1.164-2.858h1.258v-3Zm-7.748,6.516a5.014,5.014,0,1,1,5.014-5.014A5.014,5.014,0,0,1,194.532,75.695Z",
    transform: "translate(-149.192 -61.675)",
    fill: "#73b8ff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_402",
    "data-name": "Group 402",
    transform: "translate(147.086 34.437)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_792",
    "data-name": "Path 792",
    d: "M435.661,143.992a3.979,3.979,0,0,1,1.272.211,6.171,6.171,0,0,1,12.339.181c0,.156-.008.31-.019.463a3.414,3.414,0,0,1,6.267,2.516,2.451,2.451,0,1,1,1.191,4.593h-21.05a3.982,3.982,0,1,1,0-7.964Z",
    transform: "translate(-431.678 -138.213)",
    fill: "#004f9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_793",
    "data-name": "Path 793",
    d: "M454.31,153.968l-2.73-2.81h1.042v-4.616H456v4.616h1.042Z",
    transform: "translate(-442.625 -142.795)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapBanner);
export default __webpack_public_path__ + "static/media/mapBanner.208b4b6bbed421487638c4fd9197fc55.svg";
export { ForwardRef as ReactComponent };